/*
//-------------------------------------------------------
//   Copyright (c) 2024 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     DataForm
//   Details:    DataForm page
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// WI3713 24/01/24 JC       New
//-------------------------------------------------------
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { dataFormActions } from '../store/DataForm';
import Loading from '../components/Loading';
import AlertPanel from '../components/AlertPanel';
import DataFormButtons from '../components/DataFormButtons';
import DataFormRow from '../components/DataFormRow';
import Header from '../components/Header';
import NoItems from '../components/NoItems';
import Dialog from '../components/Dialog';
import { history } from '../history';
import { dataFormOwnerTypes } from '../constants/DataFormOwnerTypes';

class DataForm extends Component {
	constructor(props) {
        super(props);

        this.state = {
            ownerId: undefined,
            ownerType: undefined
        };

        //handlers
		this.handleFieldChanged = this.handleFieldChanged.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleComplete = this.handleComplete.bind(this);
        this.handleMessageBoxClose = this.handleMessageBoxClose.bind(this);        
        this.handlePrev = this.handlePrev.bind(this);

	}

    static getDerivedStateFromProps(props, state) {

        //get values from props
        let ownerId = props.match.params.ownerId;
        let ownerType = props.match.params.ownerType;

        //change of props?
        if (ownerId !== state.ownerId || ownerType !== state.ownerType) {

            //get data form
            props.getDataForm(ownerId, ownerType);

            //return new state
            return ({
                ownerId: ownerId,
                ownerType: ownerType
            });
        }

        // Return null to indicate no change to state.
        return null;
    }


    // --------------------------------------------------------------
    // field change handler
    handleFieldChanged = item => {


        //pass to store to update
        this.props.updateAnswer(item);
	}


    // --------------------------------------------------------------
    // save handler
	handleSave = event => {
        event.preventDefault();

        //save without complete
        this.props.save(false);
    }

    // --------------------------------------------------------------
    // complete handler
    handleComplete = event => {
        event.preventDefault();

        //save with complete
        this.props.save(true);
    }

    // --------------------------------------------------------------
    // message box close handler
    handleMessageBoxClose = event => {
        
        //handle message box closed
        this.props.removeMessageBoxText();
    }

    //handler for prev click
    handlePrev = event => {
        event.preventDefault();
        
        history.push(`/documents/1`);
    }

    // --------------------------------------------------------------
    // Render
    render() {
        const { error, isLoading, changedAnswers, validatedAnswers, validationError, messageBoxText, dataForm } = this.props; 

        const header = isLoading || !dataForm ? "Data form" : dataForm.dataFormSubject;

        let previousText = "Back"
        if (dataForm) {
            switch (dataForm.dataFormOwnerType) {
                case dataFormOwnerTypes.document:
                    previousText = "Documents";
                    break;
                default:
            }
        }

        const hasItems = (dataForm !== undefined && dataForm.dataFormItems !== undefined && dataForm.dataFormItems.length !== 0);

        return (
            <div>
                <Header title={header} />
                                
                {isLoading
                    ? ""
                    : <DataFormButtons location="top" isLoading={isLoading} canEdit={dataForm && !dataForm.isCompleted}
                        previousText={previousText} handlePrev={this.handlePrev} handleSave={this.handleSave} handleComplete={this.handleComplete} />
                }

                {error ? <AlertPanel type="danger" message={error} /> : []}


                {isLoading ? <Loading />
                    :
                    !hasItems ?
                        <NoItems key={"dataform-noitems"}/>
                        :
                        <div>
                            {/* message box text? */
                                messageBoxText !== undefined
                                    ? <Dialog title="Stop" message={messageBoxText} onConfirm={this.handleMessageBoxClose}
                                        confirmClass="btn-destructive" confirmText="Okay" hideCancel={true} />
                                : []}

                            {/*validation error*/}
                            {validationError !== undefined
                                ? <AlertPanel type="danger" message={validationError} />
                                : []
                            }

                            {/*show a row for each dataform item*/}
                            {dataForm.dataFormItems.map((item, i) => {

                                /* get the item, passing the answer into a new original answer field */
                                let localItem = { ...item, originalAnswer: item.answer };

                                if (localItem.lineNumber in changedAnswers) {
                                    //if there's a changed answer for the linenumber then use this for the answer instead
                                    localItem = {
                                        ...localItem, answer: changedAnswers[localItem.lineNumber].answer,
                                        hasNewAnswer: true
                                    };
                                }

                                if (localItem.lineNumber in validatedAnswers) {
                                    // if there's a validated anwer for the line number then get this as well
                                    localItem = { ...localItem, hasError: validatedAnswers[localItem.lineNumber].hasError };
                                }

                                return (
                                    <DataFormRow
                                        key={i}
                                        item={localItem}
                                        canEdit={!dataForm.isCompleted}
                                        handleFieldChanged={this.handleFieldChanged} />
                                );
                        })}
                        </div>
                }
			</div>
		);
	}
}

DataForm.propTypes = {
	//error: PropTypes.string,
	//fields: PropTypes.arrayOf(PropTypes.any),
	isLoading: PropTypes.bool.isRequired
};

export default connect(
	state => state.dataForm,
	dispatch => bindActionCreators(dataFormActions, dispatch)
)(DataForm);
